<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
//.table{
//  tr{
//    td:first-child{
//      background: #F6FAFD;
//    }
//  }
//}
.c-title small{
  margin-top: 10px;
}
.compose-type1{
  margin-top: 100px;
  padding-bottom: 50px;
  background: url("../../assets/img/Virus/Adenovirus/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
.required{
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.zaiti{
  overflow: auto;
  font-size: 16px;
}
.zaiti .desc{
  margin-bottom: 10px;
}
.zaiti ul li{
  padding-bottom: 20px;
}
.zaiti ul li:last-child{
  padding-bottom: 0;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .cons1{
    margin-top: 10px;
    float: left!important;
  }
}
</style>
<style scoped lang="scss">
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
/deep/ .case-table th {
  background: #fff !important;  
  color: #606266 !important;
  text-align: center !important;
  font-weight: 400;
}
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner con">
      <img src="@/assets/img/Virus/Adenovirus/bannerNew.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons">
      <img src="@/assets/img/two_Banner/腺病毒包装banner.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container">
        <p class="desc" style="margin-bottom: 10px;color:#014492;font-weight:bold;">腺病毒包装</p>
        <p class="desc">腺病毒(Adenovirus，ADV)是一种直径为70~90 nm、无包膜的线状双链DNA病毒，具有较强的细胞和组织感染能力。</p>
        <p class="desc">腺病毒包装技术是指通过基因工程技术对腺病毒进行改造，使其能够携带外源基因序列并有效地传递到宿主细胞中，进入细胞后携带的基因组不整合到宿主细胞基因组中，只是瞬时表达。腺病毒转染技术在心血管领域、肝脏、肌肉、肺、肿瘤及其他领域广泛应用。</p>
        <p class="desc">腺病毒载体优势为宿主范围广，表达快，载体容量大、可插入最大6 kb的外源基因，感染效率高，常用于感染难感染的细胞，非整合型，无插入致突变性，具有嗜肝性，易于感染肝细胞。但腺病毒免疫原性高，对某些对外源刺激敏感的动物模型和组织中易造成炎症，体内应用需谨慎。</p>
        <p class="desc">擎科生物所生产的腺病毒均经过超纯化处理，纯度高，不仅可以应用于细胞实验，还可用于动物实验；采用进口试剂盒检测腺病毒核酸的滴度，滴度准确。</p>
      </div>
      <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">包装系统<small>Packaging System</small></div>
        <p class="desc" style="margin-bottom: 10px;">擎科生物采用AdMax腺病毒包装系统，其工作原理是将携带外源基因的腺病毒穿梭质粒与携带了腺病毒大部分基因组的包装质粒共转染HEK293细胞，利用Cre/loxP重组酶系统的作用实现重组，产生重组腺病毒。这个系统操作简便、重组效率高、获得的病毒产率高、目的基因的表达水平高。</p>
        <div class="gene_img con" style="text-align: center"><img src="@/assets/img/Virus/Adenovirus/package.png"  width="100%"></div>
        <p style="margin-bottom: 10px;text-align:center;font-size:12px">腺病毒包装和感染原理图</p>
      </div>
      <!-- <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">服务类型<small>Service type</small></div>
        <p class="desc" style="margin-bottom: 10px;">1.过表达腺病毒</p>
        <p class="desc" style="margin-bottom: 10px;">根据客户提供的基因信息，合成目的基因的cDNA序列，并将其连接到腺病毒载体上，通过包装获得目的基因的过表达腺病毒。</p>
        <p class="desc" style="margin-bottom: 10px;">2.“三保一”干扰腺病毒</p>
        <p class="desc" style="margin-bottom: 10px;">根据客户提供的基因信息，设计和合成3条针对目的基因的shRNA模板，并将其分别连接到腺病毒载体上，通过包装获得3种干扰腺病毒。</p>
        <p class="desc" style="margin-bottom: 10px;">3.定制靶点干扰腺病毒</p>
        <p class="desc">根据客户提供的基因信息和确定的干扰序列，设计和合成1条针对干扰序列的shRNA模板，并将其连接到腺病毒载体上，通过包装获得目的基因的干扰腺病毒株。</p>
      </div> -->
      <div class="container cons">
        <div class="c-title">服务类型<small>Service type</small></div>
        <p class="desc" style="margin-bottom: 10px;">1.过表达腺病毒</p>
        <p class="desc" style="margin-bottom: 10px;">根据客户提供的基因信息，合成目的基因的cDNA序列，并将其连接到腺病毒载体上，通过包装获得目的基因的过表达腺病毒。</p>
        <p class="desc" style="margin-bottom: 10px;">2.“三保一”干扰腺病毒</p>
        <p class="desc" style="margin-bottom: 10px;">根据客户提供的基因信息，设计和合成3条针对目的基因的shRNA模板，并将其分别连接到腺病毒载体上，通过包装获得3种干扰腺病毒。</p>
        <p class="desc" style="margin-bottom: 10px;">3.定制靶点干扰腺病毒</p>
        <p class="desc">根据客户提供的基因信息和确定的干扰序列，设计和合成1条针对干扰序列的shRNA模板，并将其连接到腺病毒载体上，通过包装获得目的基因的干扰腺病毒株。</p>
      </div>
      <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">服务流程<small>Service Process</small></div>
        <div class="gene_img con" style="text-align: center"><img src="@/assets/img/Virus/Adenovirus/lc_new.png" width="100%"></div>
        <!-- <div class="gene_img cons" style="text-align: center"><img src="@/assets/img/Virus/Adenovirus/lc_2.png"></div> -->
      </div>
      <div class="container cons">
        <div class="c-title">服务流程<small>Service Process</small></div>
        <div class="gene_img con" style="text-align: center"><img src="@/assets/img/Virus/Adenovirus/lc.png"></div>
        <div class="gene_img cons" style="text-align: center"><img src="@/assets/img/Virus/Adenovirus/lc_2.png"></div>
      </div>
      <!-- <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">常用载体<small>Common carrier</small></div>
        <div class="zaiti">
          <div class="left fl">
            <p class="desc">过表达载体</p>
            <ul>
              <li>1）pDC316-mCMV-EGFP</li>
              <li>2）AD-mCMV-MCS-3FLAG-SV40-EGFP</li>
              <li>3）AD-mCMV-MCS-HA-SV40-EGFP</li>
              <li>4）AD-Mcmv-MCS-MYC- SV40-EGFP</li>
              <li>5）AD-mCMV-MCS-His-SV40-EGFP</li>
              <li>6）AD-mCMV-MYC-MCS-HA-SV40-EGFP</li>
              <li>7）AD-mCMV-MCS-3FLAG</li>
              <li>8）AD-mCMV-MCS-3FLAG-SV40-mCherry</li>
            </ul>
          </div>
          <div class="right fr cons1">
            <p class="desc">干扰载体</p>
            <ul>
              <li>1）pDC316-ZsGreen1-shRNA</li>
              <li>2）AD-hU6-MCS-CMV-EGFP</li>
              <li>3）AD-hU6-MCS-CMV-EGFP</li>
            </ul>
          </div>
        </div>
      </div> -->
      <div class="container cons" >
        <div class="c-title">常用载体<small>Common carrier</small></div>
        <div class="zaiti">
          <div class="left fl">
            <p class="desc">过表达载体</p>
            <ul>
              <li>1）pDC316-mCMV-EGFP</li>
              <li>2）AD-mCMV-MCS-3FLAG-SV40-EGFP</li>
              <li>3）AD-mCMV-MCS-HA-SV40-EGFP</li>
              <li>4）AD-Mcmv-MCS-MYC- SV40-EGFP</li>
              <li>5）AD-mCMV-MCS-His-SV40-EGFP</li>
              <li>6）AD-mCMV-MYC-MCS-HA-SV40-EGFP</li>
              <li>7）AD-mCMV-MCS-3FLAG</li>
              <li>8）AD-mCMV-MCS-3FLAG-SV40-mCherry</li>
            </ul>
          </div>
          <div class="right fr cons1">
            <p class="desc">干扰载体</p>
            <ul>
              <li>1）pDC316-ZsGreen1-shRNA</li>
              <li>2）AD-hU6-MCS-CMV-EGFP</li>
              <li>3）AD-hU6-MCS-CMV-EGFP</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">客户提供<small>Customer provided</small></div>
        <p class="desc" style="margin-bottom: 10px;">1、目的基因:名称、物种、Acession No.等</p>
        <p class="desc" style="margin-bottom: 10px;">2、目的细胞:名称、培养条件。</p>
        <p class="desc" style="margin-bottom: 10px;">3、携带标签:如GFP/RFP/PURO等。</p>
      </div> -->
      <div class="container cons" >
        <div class="c-title">客户提供<small>Customer provided</small></div>
        <p class="desc" style="margin-bottom: 10px;">1、目的基因:名称、物种、Acession No.等</p>
        <p class="desc" style="margin-bottom: 10px;">2、目的细胞:名称、培养条件。</p>
        <p class="desc" style="margin-bottom: 10px;">3、携带标签:如GFP/RFP/PURO等。</p>
      </div>
      <!-- <div class="container con">
        <div class="c-title">擎科交付<small>Tsingke delivery</small></div>
        <table class="table">
          <tr>
            <td style="width:300px;">服务项目</td>
            <td>交付</td>
          </tr>
          <tr>
            <td rowspan="4">过表达腺病毒</td>
            <td>过表达腺病毒5支，200μL/支， (滴度>1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>对照腺病毒5支，200μL/支，(滴度> 1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>实验报告1份</td>
          </tr>
          <tr>
            <td>不同位点干扰腺病毒各5支，共15支，200μL/支(滴度>1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td rowspan="3">“三保一”干扰腺病毒</td>
            <td>不同位点干扰腺病毒各5支，共15支，200μL/支(滴度>1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>对照腺病毒5支，200μL/支， (滴度>1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>实验报告1份</td>
          </tr>
          <tr>
            <td rowspan="4">定制干扰腺病毒</td>
            <td>干扰腺病毒5支，200μL/支， (滴度>1*10<sup>10</sup>PFU/mL)，</td>
          </tr>
          <tr>
            <td>对照腺病毒5支，200μL/支， (滴度> 1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>对照腺病毒5支，200μL/支， (滴度> 1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>实验报告1份</td>
          </tr>
        </table>
      </div> -->
      <div class="container cons">
        <div class="c-title">擎科交付<small>Tsingke delivery</small></div>
        <table class="table" style="margin-top: 20px;">
          <tr>
            <td style="width:300px;">服务项目</td>
            <td>交付</td>
          </tr>
          <tr>
            <td rowspan="4">过表达腺病毒</td>
            <td>过表达腺病毒5支，200μL/支， (滴度>1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>对照腺病毒5支，200μL/支，(滴度> 1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>实验报告1份</td>
          </tr>
          <tr>
            <td>不同位点干扰腺病毒各5支，共15支，200μL/支(滴度>1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td rowspan="3">“三保一”干扰腺病毒</td>
            <td>不同位点干扰腺病毒各5支，共15支，200μL/支(滴度>1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>对照腺病毒5支，200μL/支， (滴度>1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>实验报告1份</td>
          </tr>
          <tr>
            <td rowspan="4">定制干扰腺病毒</td>
            <td>干扰腺病毒5支，200μL/支， (滴度>1*10<sup>10</sup>PFU/mL)，</td>
          </tr>
          <tr>
            <td>对照腺病毒5支，200μL/支， (滴度> 1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>对照腺病毒5支，200μL/支， (滴度> 1*10<sup>10</sup>PFU/mL)</td>
          </tr>
          <tr>
            <td>实验报告1份</td>
          </tr>
        </table>
      </div>
      <!-- <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">注意事项<small>matters needing attention</small></div>
        <p class="desc" style="margin-bottom: 30px;">1、腺病毒的储存:短时间内使用可将腺病毒暂时放置于4°C保存(请尽量在三天内用完),如需长期保存需放置于-80°C,可储存6个月以上。若病毒存储时间超过6个月，在使用前建议重新滴定病毒滴度。</p>
        <p class="desc" style="margin-bottom: 10px;">2、反复冻融会降低病毒滴度，每次冻融会降低病毒滴度10%，为避免反复冻融建议按照每次的使用量对病毒进行分装。</p>
      </div> -->
      <div class="container cons" >
        <div class="c-title">注意事项<small>matters needing attention</small></div>
        <p class="desc" style="margin-bottom: 30px;">1、腺病毒的储存:短时间内使用可将腺病毒暂时放置于4°C保存(请尽量在三天内用完),如需长期保存需放置于-80°C,可储存6个月以上。若病毒存储时间超过6个月，在使用前建议重新滴定病毒滴度。</p>
        <p class="desc" style="margin-bottom: 10px;">2、反复冻融会降低病毒滴度，每次冻融会降低病毒滴度10%，为避免反复冻融建议按照每次的使用量对病毒进行分装。</p>
      </div>
      <div class="compose-type1">
        <div class="container">
          <div class="c-title">服务优势<small>Service Advantages</small></div>
            <div class="required">
              <p class="mb20" style="font-weight:bold">高滴度</p>
              <p class="mb20">高效腺病毒包装系统，</p>
              <p class="mb20">滴度约为10¹⁰-10¹¹ PFU/mL</p>
              <p class="mb20" style="font-weight:bold">高纯度</p>
              <p class="mb20">采用超速离心过滤，高纯度、低残留，可达in vivo级</p>
            </div>
        </div>
      </div>
      <div class="container con">
      <div class="c-title">服务内容<small>Service Details</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :span-method="objectSpanMethod"
            :data="tableData">
            <el-table-column
              prop="product"
              label="产品大类">
            </el-table-column>
            <el-table-column
              prop="name"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="number"
              label="总量">
            </el-table-column>
            <el-table-column
              prop="time"
              label="周期(工作日)">
            </el-table-column>
            <el-table-column
              prop="directory"
              label="目录价（元）">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注">
              <template slot-scope="scope">
                <div v-html="scope.row.remark"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="container con">
        <div class="c-title">案例展示<small>Case</small></div>
        <p class="desc" style="margin-bottom: 30px;">擎科腺病毒对不同细胞的均有较好的感染效果。</p>
        <div class="tables" >
          <el-table
            border
            class="case-table"
            :span-method="objectSpanMethod"
            :data="casetableData">
            <el-table-column
              label="病毒">
              <el-table-column
                label="MOI">
                <el-table-column
                  label="细胞">
                  <template>
                    <span>感染效果</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="ADV-CMV-EGFP">
              <el-table-column
                label="1000">
                <el-table-column
                prop="case1"
                label="231">
                  <template>
                    <img src="@/assets/img/Virus/Adenovirus/case1.png" width="90%">
                  </template>
                </el-table-column>
                <el-table-column
                  label="hBMSCS">
                  <template>
                    <img src="@/assets/img/Virus/Adenovirus/case2.png" width="90%">
                  </template>
                </el-table-column>
                <el-table-column
                  label="U251">
                  <template>
                    <img src="@/assets/img/Virus/Adenovirus/case3.png" class="img-fluid">
                  </template>
                </el-table-column>
                <el-table-column
                  label="MEF">
                  <template>
                    <img src="@/assets/img/Virus/Adenovirus/case4.png" class="img-fluid">
                  </template>
                </el-table-column>
                <el-table-column
                  label="A549">
                  <template>
                    <img src="@/assets/img/Virus/Adenovirus/case5.png" class="img-fluid">
                  </template>
                </el-table-column>
                <el-table-column
                  label="T24">
                  <template>
                    <img src="@/assets/img/Virus/Adenovirus/case6.png" class="img-fluid">
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="container cons">
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <ul class="effect-lists con">
          <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
            <img :src="`/static/images/Virus_${item.img}${currentType===index ? '' : ''}.png`">
            <p style="margin-top: 10px;">{{item.name}}</p>
          </li>
        </ul>
        <div class="cons">
          <ul class="effect-lists" style="margin-top: 20px;display: flex!important;justify-content: center!important;">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/images/Virus_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>

      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: '慢病毒包装', img: '1', ref: '/Virus/Lentivirus_packaging'},
        {name: '腺相关病毒包装', img: '3', ref: '/Virus/Adeno_associated_virus'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: '',
      tableData:[
        {
          product: "腺病毒ADV",
          name:'高纯 ADV 病毒包装',
          number:'1E+10 PFU',
          time:'55',
          directory:'6300',
          remark: `<div style="text-align:left;">
            <p>1.不包含质粒构建费用和周期</p>
            <p>2.价格包含对照</p>
          </div>`,
        },
        {
          product: "腺病毒ADV",
          name:'高纯 ADV 病毒包装',
          number:'5E+10 PFU',
          time:'55',
          directory:'9500',
          remark: '1.不包含质粒构建费用和周期;2.价格包含对照',
        },
        {
          product: "腺病毒ADV",
          name:'高纯 ADV 病毒包装',
          number:'1E+11 PFU',
          time:'55',
          directory:'13800',
          remark: '1.不包含质粒构建费用和周期;2.价格包含对照',
        },
      ],
      casetableData:[
        {
          case1: "case1.png"
        },
      ],
    }
  },
  created () {
    this.getResourceColumns()
    console.log(this.$route)
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 5) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Virus/Adenovirus_packaging.vue